import styled from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  gap: 20px;
  grid-auto-rows: max-content;
`;
